import {IAppState} from "../../state/app.state";
import {createSelector} from "@ngrx/store";
import {ILanguageState} from "../../state/application-parameters/application-parameters.state";

export const selectLanguage = createSelector(
  (state: IAppState) => state.language,
  (state:ILanguageState) => state
);
